.single-value {
    padding: 8px 0;
    width: 100%;
}
